// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b7db5c34","455":"1759ecd3","977":"d558a596"}[chunkId] + ".chunk.js";
};